import { AppSettings } from '@slerp/controls'

// eslint-disable-next-line no-unused-vars
export enum SortDirectionOptions {
  ascend = 'ASC',
  descend = 'DESC',
  none = 'NONE'
}

interface IntegrationSettings {
  composer: {
    enabled: boolean
    id: string
  }
  crm: {
    enabled: boolean
  }
}

export type MERCHANT_LAYOUT_SETTING = {
  merchants_by_pk: {
    name: string
    marketing_modal_viewers: string[]
    app_setting: Partial<AppSettings>
    integration_settings: Partial<IntegrationSettings>
    registered_company_name: string
    subscription: string
    has_onboarded: boolean
    slug: string
  }
}
